export * from "ce/plugins/Linting/utils/getEntityUniqueIdForLogs";
import { default as CE_getEntityUniqueIdForLogs } from "ce/plugins/Linting/utils/getEntityUniqueIdForLogs";
export default CE_getEntityUniqueIdForLogs;
